export default "__VITE_ASSET__fc1dc491__"